// extracted by mini-css-extract-plugin
export default {"mainWrap":"Empty_mainWrap__pqZ3f","tempyBox":"Empty_tempyBox__oXGV9","iconEmty":"Empty_iconEmty__9GuDF","titleEmty":"Empty_titleEmty__VSZGM"};